import { useContext } from 'react';

import LocalizationContext from '../../localization/LocalizationContext';
import Translation from '../../localization/translations/Translation';

export default function useTranslation(): Translation {
  const { translatedStrings } = useContext(LocalizationContext);
  return translatedStrings;
}
